import { useContext, useEffect, useRef } from 'react'

import EnvelopeOverlayContext from '@common/Routing/EnvelopeOverlayContext'

export const useReloadEnvelopesOnReturn = (loadEnvelopes: () => void): void => {
  const isEnvelopeOverlayOpen = useContext(EnvelopeOverlayContext)
  const wasEnvelopeOverlayOpen = useRef(isEnvelopeOverlayOpen)

  useEffect(() => {
    if (wasEnvelopeOverlayOpen.current && !isEnvelopeOverlayOpen) {
      loadEnvelopes()
    }

    wasEnvelopeOverlayOpen.current = isEnvelopeOverlayOpen
  }, [isEnvelopeOverlayOpen, loadEnvelopes])
}
